import useOnceEffect from "../../utils/hooks/useOnceEffect";
import "./styles.scss";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import addMoneyMask from "../../utils/addMoneyMask";
import InfoIcon from "../../assets/icons/InfoIcon";
import useInsuranceStore from "../../storeModules/useInsuranceStore";
import usePaymentStore from "../../storeModules/usePaymentStore";
import { persistInsuranceStore } from "../../utils/resumeStorage";

const InsuranceSelect = () => {
  const { setInsurance, valorPremio, isInsuranceHired } = useInsuranceStore(
    (state) => state,
  );

  const { selectedPlano } = useConsorcioStore((state) => state);

  const { insuranceMonthlyParcel } = usePaymentStore((state) => state);

  const valorParcelaCurrency = addMoneyMask(selectedPlano.planoValorParcela);
  const insuranceValueCurrency = addMoneyMask(
    selectedPlano.valorPremioSeguro || valorPremio,
  );

  const totalValueCurrency = addMoneyMask(
    insuranceMonthlyParcel || selectedPlano.planoValorParcela + valorPremio,
  );

  useOnceEffect(() => {
    setInsurance(true, "isInsuranceHired");
    setInsuranceAcceptDate("true");
  });

  const setInsuranceAcceptDate = (value) => {
    if (value === "true") {
      const currentDateTime = new Date().toISOString();
      setInsurance(currentDateTime, "termsAcceptDate");
    } else {
      setInsurance("", "termsAcceptDate");
    }
  };

  return (
    <div className="insurance">
      <p className="insurance-title">Selecione uma opção:</p>

      <div className="escolha_seguros">
        <div className="insurance-option">
          <label
            className="insurance-infos--container"
            htmlFor="insurance-option-1"
          >
            <input
              className="insurance-radio"
              value={true}
              type="radio"
              id="insurance-option-1"
              name="insurance"
              onChange={(e) => {
                setInsurance(JSON.parse(e.target.value), "isInsuranceHired");
                setInsuranceAcceptDate(e.target.value);
                persistInsuranceStore();
              }}
              checked={isInsuranceHired === true}
            />
            <div className="insurance-infos">
              <div className="insurance-tag-container">
                <div className="insurance-tag insurance-tag__green">
                  COM SEGURO
                </div>
                <div className="insurance-total">
                  <span className="insurance-total-value">
                    &nbsp;
                    {totalValueCurrency}
                  </span>
                  <div className="insurance-total-text-container">
                    <span className="insurance-total-text">&nbsp;mensais</span>
                  </div>
                </div>
              </div>
              <div className="insurance-add-value">
                <span>Valor do acréscimo:</span>{" "}
                <span className="insurance-value">
                  {insuranceValueCurrency}
                </span>
              </div>
            </div>
          </label>
        </div>

        <div className="insurance-option">
          <label
            className="insurance-infos--container"
            htmlFor="insurance-option-2"
          >
            <input
              className="insurance-radio"
              value={false}
              type="radio"
              id="insurance-option-2"
              name="insurance"
              onChange={(e) => {
                setInsurance(JSON.parse(e.target.value), "isInsuranceHired");
                persistInsuranceStore();
              }}
              checked={isInsuranceHired === false}
            />
            <div className="insurance-infos">
              <div className="insurance-tag-container">
                <div className="insurance-tag insurance-tag__grey">
                  SEM SEGURO
                </div>
                <div>
                  <span className="insurance-total-value">
                    &nbsp;
                    {valorParcelaCurrency}
                  </span>
                  <span className="insurance-total-text">&nbsp;mensais</span>
                </div>
              </div>
              <div className="insurance-add-value">
                <span>Não quero proteção</span>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default InsuranceSelect;
